import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from '@/assets/locales/de.json';
import en from '@/assets/locales/en.json';
import es from '@/assets/locales/es.json';
import fr from '@/assets/locales/fr.json';
import it from '@/assets/locales/it.json';

const RESOURCES = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
  es: {
    translation: es,
  },
  it: {
    translation: it,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: RESOURCES,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: Object.keys(RESOURCES),
  });

export default i18n;
